import { globalEvent } from '@shared/easyfy.core';

export default class Toaster {
  static Instance: Toaster;

  constructor() {
    Toaster.Instance = this;

    globalEvent({
      type: 'click',
      event: {
        action: 'remove-alerter',
        callback: Toaster.onRemoveToaster,
      },
    });
  }

  onInit() {}

  static toaster(
    severity: MessageSeverity,
    message: string,
    element?: HTMLElement,
    timeBeforeRemoved?: number,
    basketOpen?: boolean,
    extraClass?: string,
    icon?: string,
    doNotShowRemove?: boolean
  ) {
    let html = '';

    if (icon) {
      html += `<i class="icon ${icon}"></i>`;
    }

    html += `<span>${message}</span>`;

    if (!doNotShowRemove) {
      html += `<a href="#" data-action="remove-alerter" class="toaster-remove"></a>`;
    }

    let content: HTMLDivElement = document.createElement('div');
    content.className = `toaster ${extraClass != null ? extraClass : ``} ${element != null ? `` : `toaster-fixed`} ${basketOpen ? `basket-open` : ``} ${MessageSeverity[severity]}`;
    content.setAttribute('data-container', 'easy-toaster');
    content.innerHTML = html;

    if (element) {
      element.append(content);
    } else {
      document.body.appendChild(content);
    }

    if (timeBeforeRemoved == null || timeBeforeRemoved > 0) {
      setTimeout(function () {
        document.querySelectorAll<any>('[data-container="easy-toaster"]')?.forEach((element) => element.remove());
      }, timeBeforeRemoved || 3000);
    }

    return false;
  }

  static onRemoveToaster(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    const target = e.target;
    if (!target || !(target instanceof HTMLElement)) {
      return false;
    }
    const toaster = target.closest('.toaster');
    if (toaster) {
      toaster.remove();
    }

    return false;
  }
}

export enum MessageSeverity {
  success,
  warning,
  error,
}
